// src/hooks/programs/useConfirmProgram.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { confirmProgram } from "../../api/apiPrograms";
import parseError from "../../utils/parseError";

const useConfirmProgram = () => {
    const queryClient = useQueryClient();

    const {
        mutate: confirmProgramMutate,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: confirmProgram,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["program"] });
            queryClient.invalidateQueries({ queryKey: ["programs"] });

            queryClient.refetchQueries({ queryKey: ["program"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to confirm program");
        },
    });

    return {
        confirmProgramMutate,
        isPending: isPending || isLoading,
    };
};

export default useConfirmProgram;